<div class="snack-container">
    <span class="icon"><mat-icon [color]="color">{{icon}}</mat-icon></span>
    <span class="text">{{data.message}}</span>
    <span class="separator"></span>
    <span class="close" (click)="closeSnack()"><mat-icon>close</mat-icon></span>
  </div>